var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    [
      _vm.loadToRepeat
        ? _c("v-repeat-load-group-dialog", {
            attrs: {
              loadGroupId: _vm.loadToRepeat.humanId,
              sponsor: _vm.loadGroupSponsorName(_vm.loadToRepeat),
              origin: _vm._f("originName")(_vm.loadToRepeat.loadGroup.details),
              destination: _vm._f("destinationName")(
                _vm.loadToRepeat.loadGroup.details
              ),
              count: _vm.loadToRepeat.loadCount || 1,
              isMobile: _vm.isMobile,
              loading: _vm.loadingBtn,
              company: _vm.company,
              "load-group": _vm.loadToRepeat.loadGroup
            },
            on: {
              cancel: _vm.closeRepeatLoadDialog,
              newLoad: _vm.closeRepeatLoadDialog
            },
            model: {
              value: _vm.showRepeatLoadDialog,
              callback: function($$v) {
                _vm.showRepeatLoadDialog = $$v
              },
              expression: "showRepeatLoadDialog"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.selectedLoad
        ? _c("schedule-load-calendar-dialog", {
            attrs: { load: _vm.selectedLoad, "company-id": _vm.storeCompanyId },
            on: {
              repeat: function($event) {
                return _vm.repeatLoad($event)
              }
            },
            model: {
              value: _vm.showLoadDialog,
              callback: function($$v) {
                _vm.showLoadDialog = $$v
              },
              expression: "showLoadDialog"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-toolbar",
        [
          _c("v-icon", { staticClass: "pr-4", attrs: { color: "primary" } }, [
            _vm._v("sync")
          ]),
          _vm._v(" "),
          _c(
            "v-layout",
            { attrs: { column: "" } },
            [
              _c("v-toolbar-title", [
                _vm._v("\n        Weekly Recurring Load Groups\n      ")
              ]),
              _vm._v(" "),
              _c(
                "v-list-tile-sub-title",
                { staticClass: "font-weight-light font-italic" },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("site-title.brief")) +
                      " adds these load groups to your planner every week based on the repeat loads' schedule\n      "
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-sheet",
            { attrs: { height: "500" } },
            [
              _c("v-calendar", {
                ref: "calendar",
                attrs: {
                  start: _vm.recurringLoadScheduleStart,
                  color: "primary",
                  type: "week",
                  "show-month-on-first": "",
                  weekdays: [1, 2, 3, 4, 5, 6, 0]
                },
                scopedSlots: _vm._u([
                  {
                    key: "dayBody",
                    fn: function(ref) {
                      var date = ref.date
                      var timeToY = ref.timeToY
                      var minutesToPixels = ref.minutesToPixels
                      return [
                        _vm._l(_vm.loadsByDate[date], function(event, idx) {
                          return [
                            event.pendingSchedule.localPickupTime
                              ? _c("div", {
                                  key: "recurring-load-schedule-" + idx,
                                  staticClass: "my-event with-time",
                                  style: {
                                    top:
                                      timeToY(
                                        event.pendingSchedule.localPickupTime
                                      ) + "px",
                                    height: minutesToPixels(30) + "px"
                                  },
                                  domProps: {
                                    innerHTML: _vm._s(
                                      event.pendingSchedule.title
                                    )
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.open(event)
                                    }
                                  }
                                })
                              : _c(
                                  "div",
                                  {
                                    key: "recurring-load-schedule-else-" + idx,
                                    style: {
                                      top:
                                        timeToY(
                                          event.pendingSchedule.localPickupTime
                                        ) + "px",
                                      height: minutesToPixels(30) + "px"
                                    }
                                  },
                                  [_vm._v("What the H is wrong here")]
                                )
                          ]
                        })
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4fcb0cd6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4fcb0cd6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Companies/Loads/components/RecurringLoadsSchedule.vue
// module id = null
// module chunks = 